import { createFileRoute } from '@tanstack/react-router';
import { TenantOverviewPage } from '@/features/tenant-admin/pages';

export const Route = createFileRoute('/tenant-admin/overview')({
  component: TenantOverviewPage,
});
